import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { JSX, ReactNode } from "react";

/**
 * Inline text-link button — the underlined "Resend code" / "Use a different
 * account" affordances on the verification step. A real `<button>` (keyboard +
 * a11y), styled flat so it reads as a link, not a second CTA. Extracted from
 * `LoginPage.tsx`.
 */
export function TextLink({
  onClick,
  disabled,
  children,
  sx,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  sx?: SxProps<Theme>;
}): JSX.Element {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={disabled}
      sx={{
        justifySelf: "start",
        p: 0,
        border: 0,
        background: "none",
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 500,
        textDecoration: "underline",
        color: "primary.main",
        "&:hover": { color: "primary.dark" },
        "&:disabled": { cursor: "default", color: "text.disabled", textDecoration: "none" },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
